import * as React from 'react';
import type { SVGProps } from 'react';

const SvgSc = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path d="m810.84 294.39-92.316 18-115.87 14.258-14.258-33.156-36.742-12.086h-36.301l-122.1 11.031-98.102 17.555-95.398 51.371-30.301 19.273-11.699 33-5.473 34.344 25.13 7.129 23.628 19.043 46.871 8.183 7.656 22.801 37.727 49.344 103.95 80.316 61.13 58.801 59.183 48.372 23.63 9.601 30.672 48.602 12.238 34.801 29.171 18.445 18.527 32.93 9.602 37.871 30.227 5.398 13.43 15.603 19.656-30.742 30.742-21 7.945-16.656-10.945-25.727-14.71-19.211 5.113-8.473 62.473-15.816 49.87-8.63 88.657-115.13 32.543-30.226 10.43-26.773 6.742-43.5 26.473-61.055 52.055-58.57z" />
  </svg>
);
export default SvgSc;
